import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=1f77901e&scoped=true&"
import script from "./CarDetails.vue?vue&type=script&lang=ts&"
export * from "./CarDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CarDetails.vue?vue&type=style&index=0&id=1f77901e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f77901e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
